module.exports = __webpack_public_path__ + "img/jr48.d4753ea2.jpg";